<template>
    <div class="px-4 py-4 sm:px-10 sm:mt-4">
        <NftLogo :nft="nft" v-if="nft"></NftLogo>
        <div class="rounded-md bg-blue-50 p-4 mb-4" v-if="registerForm.errors.length">
            <div class="flex">
                <div class="flex-shrink-0">
                    <XCircleIcon class="h-5 w-5 text-blue-400" aria-hidden="true" />
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-blue-800">Da ist was schief gelaufen</h3>
                </div>
            </div>
        </div>
        <h2 class="text-lg leading-6 font-medium text-gray-900">{{ translate('registration.body:headline') }}</h2>

        <div class="mt-2">
            <p class="text-right"><Link :href="loginUrl" class="text-sm font-medium">{{ translate('registration.footer:login') }}</Link></p>
            <form id="reg" action="#" method="POST" class="" @submit.prevent="doRegister()">
                <div class="grid grid-cols-1 gap-y-1 gap-x-1 sm:grid-cols-6">
                    <div class="sm:col-span-3">
                        <label for="firstName" class="sr-only">{{ translate('registration.body:firstName') }}</label>
                        <div class="relative">
                            <input v-model="registerForm.firstName" id="firstName" name="firstName" type="text" :placeholder="translate('registration.body:firstNamePlaceHolder')" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="registerForm.errors.firstName">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                        </div>
                        <p class="mt-2 text-sm text-red-600" id="firstName-error">{{registerForm.errors.firstName}}</p>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="lastName" class="sr-only">{{ translate('registration.body:lastName') }}</label>
                        <div class="relative">
                            <input v-model="registerForm.lastName" id="lastName" name="lastName" type="text" :placeholder="translate('registration.body:lastNamePlaceHolder')" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="registerForm.errors.lastName">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                        </div>
                        <p class="mt-2 text-sm text-red-600" id="lastName-error">{{registerForm.errors.lastName}}</p>
                    </div>

                    <div class="sm:col-span-6">
                        <label for="email" class="sr-only">{{ translate('registration.body:email') }}</label>
                        <div class="relative">
                            <input v-model="registerForm.email" id="email" name="email" type="email" :placeholder="translate('registration.body:emailPlaceHolder')" autocomplete="email" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="registerForm.errors.email">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                        </div>
                        <p class="mt-2 text-sm text-red-600" id="email-error">{{registerForm.errors.email}}</p>
                    </div>
                    <div class="sm:col-span-6">
                        <button v-if="!submitting" type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            {{ translate('registration.body:registerButton') }}
                        </button>
                        <button v-if="submitting" type="button" class="w-full flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none">
                            <Cog6ToothIcon class="animate-spin-slow h-5 w-5 mr-3" />
                            {{ translate('registration.body:registerButtonWait') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="relative mt-6">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex justify-center text-sm">
                <span class="bg-white px-2 text-gray-500">{{ translate('registration.body:orUseSocial') }}</span>
            </div>
        </div>
        <div>
            <div class="mt-4 grid md:grid-cols-2 gap-3 grid-cols-1">
                <div>
                    <a :href="googleLink" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                        <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>
                        <span class="text-gray-700">{{translate('registration.body:google')}}</span>
                    </a>
                </div>
                <div>
                    <a :href="facebookLink" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" style="color: #4267B2">
                        <svg class="w-5 h-5 mr-2" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd" />
                        </svg>
                        <span>{{translate('registration.body:facebook')}}</span>
                    </a>
                </div>
            </div>
        </div>

    </div>

    <div class="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p class="text-xs leading-5 text-gray-500">
            {{ translate('registration.body:footerPrefix') }} <a href="#" v-on:click="termsDialogOpen = true;" class="font-medium text-gray-900 hover:underline">{{ translate('registration.body:footerTermsLabel') }}</a> {{ translate('registration.body:footerMiddle') }} <a href="#" v-on:click="privacyDialogOpen = true;" class="font-medium text-gray-900 hover:underline">{{ translate('registration.body:footerPrivacyLabel') }}</a> {{ translate('registration.body:footerSuffix') }}
        </p>
        <PrivacyDialog :open="privacyDialogOpen" @close="closePrivacyDialog"></PrivacyDialog>
        <TermsDialog :open="termsDialogOpen" @close="closeTermsDialog"></TermsDialog>

    </div>
</template>
<script>

import {useForm, usePage, Link} from "@inertiajs/inertia-vue3";
import { ExclamationCircleIcon, XCircleIcon, Cog6ToothIcon } from '@heroicons/vue/24/solid'
import PrivacyDialog from './../Common/PrivacyDialog';
import TermsDialog from './../Common/TermsDialog';
import {onMounted, ref} from "vue";
import NftLogo from "./../Common/NftLogo";
import translate from "../../../lang";


    export default {
        components: {
            Link,
            NftLogo,
            ExclamationCircleIcon,
            PrivacyDialog,
            TermsDialog,
            XCircleIcon,
            Cog6ToothIcon
        },
        props: {
            nft: Object,
            email: String,
            redirectTarget: String,
        },

        setup(props) {
            const privacyDialogOpen = ref(false)
            const closePrivacyDialog = () => {
                privacyDialogOpen.value = false;
            } ;
            const termsDialogOpen = ref(false)
            const closeTermsDialog = () => {
                termsDialogOpen.value = false;
            } ;

            const registerForm = useForm({
                email: props.email,
                firstName: null,
                lastName: null,
            })

            const submitting = ref(false);

            let regUrl = window.route('auth_register_submit_localized');
            let loginUrl = route('auth_login_display_localized');
            if(props.nft) {
                regUrl = window.route('loc_upload_register', {nft: props.nft.id});
                loginUrl = route('auth_login_display_localized', {_rt: route('loc_upload_login_redirect', {nft: props.nft.id})});
            }

            function doRegister() {
                submitting.value = true;
                registerForm.clearErrors();
                registerForm.post(regUrl, {
                    onError: () => {
                        submitting.value = false;
                        registerForm.reset('password');
                    }
                });
            }

            let pGoogle = { driver: 'google' };
            let pFacebook = { driver: 'facebook' };

            if(props.nft) {
                pGoogle.nft = props.nft.id;
                pFacebook.nft = props.nft.id;
            }
            const googleLink = route('socialite_auth', pGoogle);
            const facebookLink = route('socialite_auth', pFacebook);
            return {
                submitting,
                doRegister,
                registerForm,
                regUrl,
                loginUrl,
                privacyDialogOpen,
                closePrivacyDialog,
                termsDialogOpen,
                closeTermsDialog,
                translate: props.nft ? translate('upload-' + usePage().props.value.metaDataType.type) : translate('auth'),
                termsLink: window.route('terms'),
                privacyLink: window.route('privacy'),
                googleLink,
                facebookLink,
            }
        }
    }

</script>
